import script from "./MallMyHomePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MallMyHomePage.vue?vue&type=script&setup=true&lang=ts"

import "./MallMyHomePage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__